// extracted by mini-css-extract-plugin
export default {"TableContainer":"OperationalCostsTable_TableContainer__jGn2p"};